export enum VoicePlatform {
  VOLC = 'volc',
  // volc单向流式请求
  VOLC_SINGLE_STREAM = 'volc_single_stream',
  ELEVENLABS = 'elevenlabs',
  FISH_AUDIO = 'fish_audio',
}

export interface VoiceSettingsMap {
  [VoicePlatform.VOLC]: {
    speaker: string
    /* 语速，取值范围[-50,100]，100代表2.0倍速，-50代表0.5倍数 */
    speechRate?: number
    /* 音调，取值范围[-12,12]，12代表高音，-12代表低音 */
    pitchRate?: number
  }
  [VoicePlatform.ELEVENLABS]: {
    voiceId: string
    model: ElevenLabsModel
    stability: number
    /* 参数用于调整生成的语音与输入文本的相似度。通过增加该值，可以使生成的语音更加贴近于输入文本的发音和语调 */
    similarityBoost: number
  }
  [VoicePlatform.VOLC_SINGLE_STREAM]: {
    speaker: string
    /* 语速，取值范围[0.2,3]，默认为1 */
    speechRatio: number
    /* 音量，取值范围[0.1,3]，默认为1 */
    volumeRatio: number
    /* 音调，取值范围[0.1,3]，默认为1 */
    pitchRatio: number
  }
  [VoicePlatform.FISH_AUDIO]: {
    // TODO
    model: string
    latency: FishAudioLatency
    speed: number
    volume: number
    chunkLength: number
    // 数字是否格式化
    normalize: boolean
  }
}

export enum ElevenLabsModel {
  ELEVEN_TURBO_V2_5 = 'eleven_turbo_v2_5',
}
export enum FishAudioLatency {
  NORMAL = 'normal',
  BALANCED = 'balanced',
}

interface VoiceType<T extends VoicePlatform> {
  platform: T
  settings: VoiceSettingsMap[T]
}

export type Voice = VoiceType<VoicePlatform.VOLC> | VoiceType<VoicePlatform.ELEVENLABS> | VoiceType<VoicePlatform.FISH_AUDIO>

export const defaultVoice: Voice = {
  platform: VoicePlatform.VOLC,
  settings: {
    speaker: 'zh_female_wanwanxiaohe_moon_bigtts',
    speechRate: -10,
    pitchRate: 0,
  },
}
